import { PORTFOLIO } from "@/lib/site";
import Reveal from "@/components/Reveal";

export default function Portfolio() {
  return (
    <section
      data-testid="portfolio-section"
      id="work"
      className="relative bg-[#0E1213] py-24 md:py-32 lg:py-40"
    >
      <div className="px-6 md:px-12 lg:px-16 max-w-7xl mx-auto">
        <Reveal>
          <div className="flex items-center gap-4 mb-8">
            <span className="block w-10 h-px bg-[#3FB8DC]" />
            <span className="eyebrow">Recent Work</span>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end mb-16">
          <Reveal delay={80} className="lg:col-span-8">
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#F4F0EB] leading-[1.02] tracking-tight">
              Quiet plumbing.
              <br />
              <span className="italic text-[#A1A1AA]">Loud interiors.</span>
            </h2>
          </Reveal>
          <Reveal delay={200} className="lg:col-span-4">
            <p className="text-[#A1A1AA]">
              A handful of recent projects across Sydney.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
        {PORTFOLIO.map((p, i) => (
          <Reveal
            key={p.title}
            delay={i * 80}
            className="zoom-wrap group relative aspect-[4/5] overflow-hidden bg-[#0E1213] border-0"
          >
            <div data-testid={`portfolio-item-${i}`} className="h-full">
              <img
                src={p.url}
                alt={p.title}
                className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#080A0B]/95 via-[#080A0B]/30 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                <span
                  className="eyebrow block mb-2"
                  style={{ fontSize: "0.6rem" }}
                >
                  {p.tag}
                </span>
                <h3 className="font-serif-display text-2xl md:text-3xl text-[#F4F0EB] leading-tight">
                  {p.title}
                </h3>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
